/// <reference path="Telephony.d.ts" />
namespace Umbrella.Modules.TelephonyControl {
    import PhoneUserStatus = Umbrella.TelephonyControl.PhoneUserStatusModel;
    export interface IPhoneUserStatusResource
        extends angular.resource.IResource<
            Umbrella.TelephonyControl.PhoneUserStatusModel
        > {}

    export interface IPhoneStatusesParams {
        ids: System.Guid[];
    }

    interface IResourceParams {
        action?: string;
        page?: number;
        pageSize?: number;
        id?: string;
        userId?: string;
    }

    export interface IPhoneUserStatusResource
        extends angular.resource.IResourceClass<IPhoneUserStatusResource> {
        getStatusByIds(
            params: IPhoneStatusesParams
        ): ng.resource.IResource<
            Umbrella.TelephonyControl.PhoneUserStatusModel[]
        >;
    }

    class PhoneUserStatusResource {
        static $inject = ['$resource'];

        constructor(public $resource: angular.resource.IResourceService) {}

        getPhoneUserStatusResource(): IPhoneUserStatusResource {
            return this.$resource<
                Modules.Colleagues.ColleagueModel.Detailed,
                IPhoneUserStatusResource
            >(
                '/api/v1/phoneuserstatus/:action/:id',
                {},
                {
                    getStatusByIds: this.getResource('GET', true, {
                        action: 'getstatusbyids'
                    })
                }
            );
        }

        private getResource(
            method: string,
            isArray: boolean,
            params?: IResourceParams,
            headers?: any
        ): angular.resource.IActionDescriptor {
            return { method, isArray, params, headers };
        }
    }
    angular
        .module('Telephony')
        .service('PhoneUserStatusResource', [
            '$resource',
            $resource =>
                new PhoneUserStatusResource(
                    $resource
                ).getPhoneUserStatusResource()
        ]);
}
